import groq from 'groq';

import { SOCIAL_MEDIA_STORY } from '../common/socialMediaStory';
import { PRODUCT_SLUG } from '../product';

export const WALL_OF_LOVE = groq`
  name,
  title,
  items[] {
    _key,
    _type == 'socialMediaStory' => @ -> {
      ${SOCIAL_MEDIA_STORY}
    },
    _type == 'featuredReview' => @-> {
      _type,
      title,
      body,
      rating,
      verifiedBuyer,
      "customer": customerName,
      productId,
      "photoUrls": images[],
      "videoUrls": videos[],
      product-> { ${PRODUCT_SLUG} }
    }
  }
`;

export const WALL_OF_LOVE_BLOCK = groq`
  _type == 'wallOfLove' => @-> {
    ${WALL_OF_LOVE}
  }
`;
